import { Action } from '../actions';
import { CLOSE_HELP, OPEN_HELP, UPDATE_HELP } from '../actions/help';
import { HelpState, State } from '../typings/state';

export const helpInitialState = {
    opened: false
};

export function help(
    state: HelpState = helpInitialState,
    action: Action,
    fullState: State
): HelpState {
    switch (action.type) {
        case OPEN_HELP: {
            return {
                ...state,
                opened: true,
                helpId: action.id
            };
        }
        case UPDATE_HELP: {
            return {
                ...state,
                helpId: action.id
            };
        }
        case CLOSE_HELP: {
            return {
                ...state,
                opened: false
            };
        }
        default:
            return state;
    }
}
